import React, { Component } from 'react'; 
import {Row, Col, Button, Table} from 'react-bootstrap';
import _ from 'lodash';
import DropDown from './DropDown'
import Record from './Record.js'
import NoRecord from './NoRecord.js'
import moment from "moment";

export default class AuditorScreen extends Component {
  constructor(props){
    super(props)
    this.state={      
      norecord: false,
      NA:false ,
      Fatal:false ,
      feedback:'',
      additionalField:[],
      toggle:true,
      toggleA:false,
      toggleI:true,
      toggleF:false,
      norecordAvailable:false,
      audioPlay: false,
      sourceNode: null,
      currentTime: 0,
      audioContext: null,    
    } 
    this.copyData = [];
    this.isRating=false;
    this.isRatingYes=false;
    this.isNCReason1=false;
    this.isNCReason2=false;
    this.isNCReason3=false;
    this.isNCReason4=false;
    this.isNCReason5=false;
  }
  componentDidMount(){
    const{auditorJson} = this.props    
    this.createTemplate(auditorJson.templateValue.Parameters) 
    this.additionalFieldBody(auditorJson.templateValue.Additional)
  }
  componentWillMount(){
    //var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    //var today = new Date(),
    //date = today.getDate() +  '-' +  months[today.getMonth()] + '-' + today.getFullYear();
    //let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    let dateTime =  moment().format('YYYY-MM-DD HH:mm:ss')
    let date =  moment().format('YYYY-MM-DD HH:mm:ss')
    this.setState({date:date, dateTime:dateTime})
  }
  componentWillUnmount() {
    this.resetAudio();
  }
  norecordhandle = (e) =>{
    this.setState({norecord:e.target.checked})
  }
  norecordhandleClose = (e) =>{
    this.setState({norecord:false, norecordAvailable:false})
  }
  norecordCallback = () =>{
    this.setState({norecordAvailable:true, norecord:false})
  }
  
  handleFeedback = (e) => {
    this.setState({feedback:e.target.value})
  }
  handleNA = (e, rowIndex) => {    
    let x= e.target.checked;
    this.setState((prevState) =>{
      if(typeof (prevState['NA'+rowIndex]) !== "undefined"){
        this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':!prevState['NA'+rowIndex]})
        return {['NA'+rowIndex]: !prevState['NA'+rowIndex]};
      } else {
        this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':x})
        return this.setState({['NA'+rowIndex]:x})
      }
    })
   //  this.setState({['NA'+rowIndex]:e.target.checked})
    // this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':e.target.checked})
 }
  handleFatal = (e, rowIndex) => {
 this.setState({['Fatal'+rowIndex]:e.target.checked})
 this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'Fatal':e.target.checked})
  }
  handleFeedbackText = (e, rowIndex) => {
    this.setState({['textval'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'feedback':e.target.value})
  }
  
  calculateReasons = (newObj, id, i, t) => {  
    let retobj = []
    retobj.push(<option value=''>Select NC Reason</option>)
    _.map(newObj, (x)=> {
      retobj.push(<option selected={this.state['reason'+i+t] === x.label} value={x.label} >{x.label}</option>)
      return null;
    })
    if(!_.isEmpty(newObj) && !_.isEmpty(id)){
      this.copyData[i]= ({...this.copyData[i], [id]:this.state['reason'+i+t] ? this.state['reason'+i+t] : ''})
    }
    return retobj;
  }
  handleChangeReason = (object, e, rowIndex, i) => {
    this.setState({['reason'+rowIndex+i]:e.target.value})
    if(!_.isEmpty(e.target.value)){
        if(this.state['ma'+e.target.id+rowIndex] === true){
          this.setState({['ma'+e.target.id+rowIndex]:false})
        }
    }
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], [e.target.id]:e.target.value})
  }
  handleChange = (e,rowIndex) => {
    this.setState({['rating'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "rating":e.target.value})
  }
  handleChangeRating= (e,rowIndex) => {
    this.setState({['textrating'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "textrating":e.target.value})
  }
  
  createTemplate = (json) => {
    let templateObj = [];
    _.map(json, (obj, paramindex) => {
      _.map(obj.attributes, (val, index) => {
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            let isParamDisable = ((paramindex < index) || (index < questindex)) ? true : false;
            let isAttribDisable = (index < questindex) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
            if(tt.textRating === true){
              this.isRatingYes=true
            } else {
              this.isRating = true
            }
            if(tt.NCReason1 === true){
              this.isNCReason1=true
            } 
            if(tt.NCReason2 === true){
              this.isNCReason2=true
            } 
            if(tt.NCReason3 === true){
              this.isNCReason3=true
            } 
            if(tt.NCReason4 === true){
              this.isNCReason4=true
            } 
            if(tt.NCReason5 === true){
              this.isNCReason5=true
            } 
          });
        });
      });
    });
    this.setState({ templateObj});
  }
  renderDocument(fieldValue){
    if(!_.isEmpty(fieldValue)){
    let firstObject=[]; let secondObject=[]; let thirdObject=[] ; let fourthObject=[];
    //let n = fieldValue.length;
    _.map(fieldValue, (obj, i)=>{  
      (i < 4)  ? 
        firstObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) : (i <8 ) ?
        secondObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) : (i < 12) ?
        thirdObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>)  :     
        fourthObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>)
      })
      
     let returnObj = (   
        <Row className='information'>
        <Col>{firstObject}</Col>
        <Col>{secondObject}</Col>
        <Col>{thirdObject}</Col>
        <Col>{fourthObject}</Col>
        </Row>)
    return returnObj
     }
  }
  calculateOptions = (min, max, rowIndex) => {
    let UI =[]
    let selectedval = (typeof this.state['rating'+rowIndex] !== 'undefined') ? this.state['rating'+rowIndex] : max
    for(let j=min; j<=max; j++){
      let isEqual = _.isEqual(selectedval,j.toString())
      UI.push(<option selected={isEqual} value={j}>{j}</option>)
    }
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "rating":selectedval})
    return UI;
  }
  RatingOptions = (rowIndex) => {
    let UI =[]
    UI.push(<option selected={this.state['textrating'+rowIndex] === 'yes'} value='yes'>Yes</option>,
    <option  selected={this.state['textrating'+rowIndex] === 'no'} value='no'>No</option>)
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "textrating":this.state['textrating'+rowIndex] ? this.state['textrating'+rowIndex] : 'yes'})
    return UI;
  }
  renderBody = () =>{
    const {templateObj} = this.state;  
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        let Scores = row.Scoring.value 
        return (
          <tr key={row.key}>
            <td className='Assesment'>{row.Parameters.value.label}</td>
            <td className='Assesment'>{row.Attributes.value.label === 'null' ? '' : row.Attributes.value.label}</td>
            <td className='Assesment'>{row.Questions.value.label === 'null' ? '' : row.Questions.value.label}</td>
            <td><center>{Scores.weight}</center></td>
            <td>
              {(Scores.NA) ? <label><input type='radio' 
              checked={this.state['NA'+rowIndex]}
              onClick={(e)=>this.handleNA(e, rowIndex)}/></label> :'' }</td>
           {this.isRatingYes  ? <td>
              {(Scores.textRating) ? <label className={(this.state['NA'+rowIndex] || this.state['Fatal'+rowIndex]) ? 'disabled'  :''}>
              <select id='Rating'  onClick={(e)=>this.handleChangeRating(e, rowIndex)}>
              {this.RatingOptions(rowIndex)}</select></label> :'' }</td> : null}
          {this.isRating  ?
             <td>{(Scores.textRating === false || typeof Scores.textRating === 'undefined') ?
              <label className={(this.state['NA'+rowIndex] || this.state['Fatal'+rowIndex]) ? 'disabled'  :''}><select id='Rating' 
                 onClick={(e)=>this.handleChange(e, rowIndex)}> 
              {this.calculateOptions(Scores.min, Scores.max, rowIndex)}</select></label> : null}</td>: null}
            <td>
              {(Scores.Fatal) ? <label className={(this.state['NA'+rowIndex])  ? 'disabled'  :''}><input type='checkbox' checked={this.state['Fatal'+rowIndex]}
              value={this.state['Fatal'+rowIndex]}
                  onClick={(e)=>this.handleFatal(e, rowIndex)} /></label> :'' }</td>
            {this.isNCReason1 ?  <td className='Assesment'><p>
              {(Scores.NCReason1 === true ) ? <label  className={this.state['maNCReason1'+rowIndex] === true ? 'NCReason mandatColor': 'NCReason'}>
                <select id='NCReason1' onClick={(e)=>this.handleChangeReason('NC Reason 1', e, rowIndex, 0)}>
                {this.calculateReasons(Scores['NC Reason 1object'], 'NCReason1', rowIndex, 0)}</select> </label> : '' }  </p>
            </td> : null}
            {this.isNCReason2 ? <td className='Assesment'><p>
              {(Scores.NCReason2 === true) ? <label className={this.state['maNCReason2'+rowIndex] === true ? 'NCReason mandatColor': 'NCReason'}>
              <select id='NCReason2' onClick={(e)=>this.handleChangeReason('NC Reason 2', e, rowIndex, 1)}>
              {this.calculateReasons(Scores['NC Reason 2object'], 'NCReason2', rowIndex, 1)}</select> </label> : '' }</p> 
            </td> : null}
            {this.isNCReason3 ?<td className='Assesment'><p>
              {(Scores.NCReason3 === true) ? <label className={this.state['maNCReason3'+rowIndex] === true ? 'NCReason mandatColor': 'NCReason'}>
                <select id='NCReason3' onClick={(e)=>this.handleChangeReason('NC Reason 3', e, rowIndex, 2)}>
                {this.calculateReasons(Scores['NC Reason 3object'], 'NCReason3', rowIndex, 2)}</select> </label> : '' }  </p>
            </td>: null}
            {this.isNCReason4 ? <td className='Assesment'>
              {(Scores.NCReason4 === true) ? <label className={this.state['maNCReason4'+rowIndex] === true ? 'NCReason mandatColor': 'NCReason'}>
                <select id='NCReason4' onClick={(e)=>this.handleChangeReason('NC Reason 4', e, rowIndex, 3)}>
                {this.calculateReasons(Scores['NC Reason 4object'], 'NCReason4' , rowIndex, 3)}</select> </label> : '' }<br/>
            </td>: null}
            {this.isNCReason5 ? <td className='Assesment'><p>
                {(Scores.NCReason5 === true) ? <label className={this.state['maNCReason5'+rowIndex] === true ? 'NCReason mandatColor': 'NCReason'}>
                <select id='NCReason5' onClick={(e)=>this.handleChangeReason('NC Reason 5', e, rowIndex, 4)}>
                {this.calculateReasons(Scores['NC Reason 5object'], 'NCReason5', rowIndex, 4)}</select> </label> : '' }
                </p>
            </td> : null}
            <td className='Assesment'>
              <label><textarea style={{width:'100%'}}type='text' value={this.state['textval'+rowIndex]} 
              onChange={(e)=>this.handleFeedbackText(e, rowIndex)} /></label></td>
            </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );

  }
  additionalFieldBody = (Additional) => {
    let DropDownObj=[], TextBoxObj=[], TextareaObj=[]
    if(!_.isEmpty(Additional)){     
        _.map(Additional, (data, index)=>{
        if(data.label === 'Drop Down'){
          DropDownObj.push (<div className='additionalInfo'>                  
            <DropDown options={data.additionalValues} object={data} onCallBack={(a)=>this.handleSelectDropDown(a, index)}/></div>);
        }
        else if(data.label === 'Text Box'){
          TextBoxObj.push ( <div className='additionalInfo'>
          <label><b>{data.labelObj}</b><br/><input type='text' value={this.state['addtext'+index]}
          onChange={(e)=>this.handleSelectTextBar(e, index, 'Text Box')}/></label></div>)
        }
        else if(data.label === 'Text Area'){
          TextareaObj.push (  <div className='additionalInfo'>
          <label><b>{data.labelObj}</b><br/><textarea value={this.state['addtext'+index]}
          onChange={(e)=>this.handleSelectTextBar(e, index, 'Text Area')}/></label></div>)
        }
        
      })
    let returnVal  = (<div><Row>{DropDownObj}</Row><Row>{TextBoxObj}</Row><Row>{TextareaObj}</Row></div>)
    this.setState({additionalField:returnVal})
    }
   
  }
  handleSelectDropDown = (a, index) => {
    const{auditorJson} = this.props
    auditorJson.templateValue.Additional[index].selected = a;
  }
  handleSelectTextBar = (e, index, label) =>{
    const{auditorJson} = this.props
    this.setState({['addtext'+index]:e.target.value})
    if(label === 'Text Area'){
     auditorJson.templateValue.Additional[index].textAreaValues = e.target.value;
    } else {
      auditorJson.templateValue.Additional[index].textBoxValues = e.target.value;      
    }
  }

  onSubmit = () => {
    let obj = {'Scores':this.copyData, 'NoRecord':this.state.norecordAvailable,
    'FinalFeedback':this.state.feedback,
    "EvaluationDate": this.state.date,
    "QAName": this.props.loginUserName}
    let data = this.validate()
    if(data === false){
    this.props.closeModal()
    let object;
    if(!this.state.norecordAvailable){
     object = {...this.props.auditorJson.templateValue, 'Readonly':obj}
    } else {
      object = {'NoRecord':this.state.norecordAvailable}
    }
    //let startDate = this.state.date+" "+this.state.time
    var now  = this.state.dateTime
    //var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    //var today = new Date();
    //let enddate = today.getDate() +  '-' +  months[today.getMonth()] + '-' + today.getFullYear();
    //let timeSubmit = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    //let endDated = enddate+" "+timeSubmit
    var then = moment().format('YYYY-MM-DD HH:mm:ss'); 
    this.props.action.TokenValidation()      
    this.props.action.auditorEvaluationSubmit(object, this.props.id, this.state.audioBlob,now, then)
    }
  }
  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
    };
    
  }
  Record = async (audioBlob) =>{
    this.getBase64(audioBlob, (result) => {
      let idCardBase64 = result;   
      this.setState({audioBlob:idCardBase64})
      this.setupAudio(idCardBase64)
    });   
     //var binary = await blobToBase64String(audioBlob)  
    
  }

  // play = async () =>{
  //   if(typeof this.state.audioBlob !== 'undefined'){  
  //   const x = new Audio()
  //    x.src = this.state.audioBlob
  //    x.play()
  //   }
  // }

  resetAudio = () => {
    // Stop and release the previous audio source node
    if (this.state.sourceNode && this.state.sourceNode.context.state === 'running') {
      this.state.sourceNode.stop();
      this.state.sourceNode.disconnect();
    }

    // Close the previous audio context
    if (this.state.audioContext) {
      this.state.audioContext.close();
    }
  };
  setupAudio = (audioBase) => {
    let url = audioBase
    if (!_.isEmpty(url)) {
      this.resetAudio(); // Reset previous audio before setting up the new audio

      const audioContext = new (window.AudioContext || window.webkitAudioContext)();

      // Convert base64-encoded audio data to ArrayBuffer
      const base64Data = url.split(",")[1];
      const binaryString = window.atob(base64Data);
      const byteArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
      }
      const audioBuffer = byteArray.buffer;

      audioContext.decodeAudioData(audioBuffer, (buffer) => {
        this.setState({ buffer, audioContext });
      });
    }
  };
  playStart = () => {
    const { sourceNode, currentTime, audioContext } = this.state;
    this.setState({ audioPlay: true });

    // Create a new AudioBufferSourceNode for each play
    const newSourceNode = audioContext.createBufferSource();
    newSourceNode.buffer = this.state.buffer;
    newSourceNode.connect(audioContext.destination);
    newSourceNode.onended = () => {
      this.setState({ audioPlay: false });
    };

    // Store the new source node in the state
    this.setState({ sourceNode: newSourceNode });

    // Start playing from the last paused time
    newSourceNode.start(0, currentTime);
  };
  playPause = () => {
    this.setState({ audioPlay: false, currentTime: this.getCurrentTime() });
    
    // Stop and disconnect the current source node if it's playing
    if (this.state.sourceNode && this.state.sourceNode.context.state === 'running') {
      this.state.sourceNode.stop();
      this.state.sourceNode.disconnect();
    }
  };
  getCurrentTime = () => {
    const audioContext = this.state.sourceNode.context;
    return audioContext.currentTime - this.state.sourceNode.context.currentTime;
  };

  handleAssesment = () =>{
    this.setState((prevState) =>{
      return {toggle: !prevState.toggle};
    })
  }
  handleAdditional = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  handleFeedbackToggle = () =>{
    this.setState((prevState) =>{
      return {toggleF: !prevState.toggleF};
    })
  }
  handleInformation = () =>{
    this.setState((prevState) =>{
      return {toggleI: !prevState.toggleI};
    })
  }
  validate = () =>{
    const {templateObj} = this.state;
    // let key =[];
    // let mandat =[];
    let returnObj = false;
    _.map(this.copyData, (obj, index) => {
        let Score = templateObj[index]
        if(!_.isEmpty(Score)){
          let max = Score.Scoring.value.max
          let NCReason1 = Score.Scoring.value.NCReason1
          let NCReason2 = Score.Scoring.value.NCReason2
          let NCReason3 = Score.Scoring.value.NCReason3
          let NCReason4 = Score.Scoring.value.NCReason4
          let NCReason5 = Score.Scoring.value.NCReason5
          if(obj.rating < max || obj.textrating === 'no'){
            if(NCReason1 === true && obj.NCReason1 === '') {
              this.setState({['maNCReason1'+index]:true})
              returnObj = true
            } 
            else if(NCReason2 === true && obj.NCReason2 === '') {
              this.setState({['maNCReason2'+index]:true})
              returnObj = true
            }
            else if(NCReason3 === true && obj.NCReason3 === '') {
              this.setState({['maNCReason3'+index]:true})
              returnObj = true
            }
            else if(NCReason4 === true && obj.NCReason4 === '') {
              this.setState({['maNCReason4'+index]:true})
              returnObj = true
            }
            else if(NCReason5 === true && obj.NCReason5 === '') {
              this.setState({['maNCReason5'+index]:true})
              returnObj = true
            }
          }
          //  else {
          //   key = _.keys(this.state)
          //   mandat = _.filter(key, _.matches('maNCReason'))
          //     _.map(mandat, (obj) => {
          //       if(this.state[obj] === true){
          //         this.setState({[obj]:false})
          //         returnObj = false
          //       }
          //   })
          // }
        } 
      
    })
    return returnObj
    
  }
  validateForm = () => {
    const {feedback} = this.state
    if(feedback.length >0){
      return true
    }
  }
  render(){
    const{toggle, toggleA, toggleF, toggleI, additionalField}= this.state;
    return(
      <div > 
        {!_.isEmpty(this.props.fieldValue) ?
        <p>
        <h6 className={toggleI ? 'evalFormMargin': 'evalForm'} onClick={this.handleInformation} >
        {toggleI ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>INFORMATION </b></h6>  
        <div className={toggleI ? 'assesmentShow': 'assesmentHide'}>      
        {this.renderDocument(this.props.fieldValue)}</div></p> : null }        
        <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleAssesment}>
        {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>ASSESMENT</b></h6>        
        <div className={toggle ? 'assesmentShow': 'assesmentHide'}>
          <div className={this.props.formread === true ? '': ''}>
        {!this.props.formread ?      
        <label className='norecord'><input type='checkbox' checked={this.state.norecordAvailable}
         onClick={this.norecordhandle} />No recording available</label> : null }
        {this.state.norecord ?
          <NoRecord onCallBack={this.norecordCallback} closeRecord={this.norecordhandleClose}  />
          : null
        }
        <Table className={this.state.norecordAvailable ? 'disabled' :''} responsive> 
          <thead>
            <tr>
              <th>Parameters</th>
              <th>Attributes</th>
              <th>Questions</th>
              <th>Wtg.</th>
              <th>NA</th>
              {this.isRatingYes ? <th>Rating<br/>(Y/N)</th> : null}      
              {this.isRating  ?<th>Rating</th> : null}
              <th>Fatal</th>
              {this.isNCReason1 ? <th style={{width:'250px'}}>NCReason 1</th> : null}
              {this.isNCReason2 ?<th style={{width:'250px'}}>NCReason 2</th> : null}
              {this.isNCReason3? <th style={{width:'200px'}}>NCReason 3</th> : null}
              {this.isNCReason4 ?<th style={{width:'200px'}}>NCReason 4</th> : null}
              {this.isNCReason5 ? <th style={{width:'200px'}}>NCReason 5</th> : null}
              <th style={{width:'160px'}}>Feedback</th>
            </tr>
          </thead>
          <tbody>
            {
              this.renderBody()
            }
        </tbody>
        </Table>
        </div>
        </div>
        {(!_.isEmpty(additionalField)) ?
        <div>
        <h6 className={toggleA ? 'evalFormMargin': 'evalForm'} onClick={this.handleAdditional}>{toggleA ? <i class="fas fa-caret-down"/> :
         <i class="fas fa-caret-right"/>} <b>ADDITIONAL INFORMATION</b></h6> 
        <div className={toggleA ? 'assesmentShow': 'assesmentHide'}> <div className={this.props.formread === true ? '': ''}>       
        {this.state.additionalField} </div></div></div> : null}
        {!this.props.formread ?
        <div>
        <h6 className={toggleF ? 'evalFormMargin': 'evalForm'} onClick={this.handleFeedbackToggle}>{toggleF ? <i class="fas fa-caret-down"/> : 
        <i class="fas fa-caret-right"/>} <b>FEEDBACK</b></h6> 
        <div className={toggleF ? 'assesmentShow': 'assesmentHide'}>
          <Row>            
            <Col style={{'marginLeft':'10px'}}>
              <b> Evaluation Date </b>: {this.state.date}<br/>
              <b> QA Name </b> : {this.props.loginUserName} 
            </Col>
            
            <Col md={2}><b> Record </b>:<Record onCallBackRecord={this.Record}/> <br/>
            {/* <b> Play </b>: &nbsp; */}
            {/* <i class="fas fa-play" onClick={this.play}></i> */}

            {(this.state.audioBlob)?
              <>
                <b> Play </b>: &nbsp; 
                {this.state.audioPlay ? (
                    <>
                    <i className="fas fa-stop" onClick={this.playPause}></i>
                    <div className="wav_center">
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                    </div>
                    </>
                  ) : (
                    <i className="fas fa-play" onClick={this.playStart}></i>
                  )}
                  <br/>  
              </> :null}

            </Col> 
            <Col >
            
            <textarea style={{'width':'100%'}}
            value={this.state.feedback} 
            onChange={this.handleFeedback}/>
            </Col>
             
             <Col md={1}><Button className='buttonwidth' disabled={!this.validateForm()}onClick={this.onSubmit}>Submit</Button></Col>
             <Col md={1}></Col>
            </Row>
              </div>             
           
        </div> : null }
      </div>
     // </div>
    )
  }
}